import TruckIcon from "assets/images/ServicesBar/truck.svg";
import MoneyIcon from "assets/images/ServicesBar/money.svg";
import SupportIcon from "assets/images/ServicesBar/support.svg";
import { FooterMenu } from "./Footer/MenuSection";

export const Services = [
  {
    text: "Оторизиран сервиз",
    icon: SupportIcon,
  },
  {
    text: "Безплатна доставка",
    icon: TruckIcon,
  },
  {
    text: "Eдна вноска подарък",
    icon: MoneyIcon,
  },
];

export const Stores = [
  {
    title: "Магазин Карлово",
    city: "гр. Карлово",
    address: 'бул. "Ген.Карцов" 27 (Ханът)',
    tel1: "+359 889 269946",
    tel2: "+359 882 930771",
    iframeSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2934.92198717782!2d24.804925815465246!3d42.641813779169034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a997b35d0a63c7%3A0x3691f94a2501bc46!2z0Jgg0JrQm9CY0JzQkA!5e0!3m2!1sbg!2sbg!4v1603097469203!5m2!1sbg!2sbg",
  },
  {
    title: "Шоурум Пловдив",
    city: "гр. Пловдив",
    address: 'бул. "Руски" 119',
    tel1: "+359 894 468 805",
    tel2: "+359 889 269946",
    footer: {
      address: null,
      phones: ["0886560510"],
    },
    iframeSrc:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11833.933867166226!2d24.74202!3d42.13994!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa7da6c7883299ac6!2z0Jgg0JrQm9CY0JzQkCAtINCc0LDQs9Cw0LfQuNC9INC30LAg0LrQu9C40LzQsNGC0LjRhtC4INCx0YPQuy4g0KDRg9GB0LrQuA!5e0!3m2!1sbg!2sbg!4v1603103132190!5m2!1sbg!2sbg",
  },
  {
    title: "Офис Габрово",
    city: "бул. “Априлов “ 26 (срещу козирката)",
    tel1: "+359 878 650548",
    tel2: "+359 898 560037",
    iframeSrc:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11833.933867166226!2d24.74202!3d42.13994!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa7da6c7883299ac6!2z0Jgg0JrQm9CY0JzQkCAtINCc0LDQs9Cw0LfQuNC9INC30LAg0LrQu9C40LzQsNGC0LjRhtC4INCx0YPQuy4g0KDRg9GB0LrQuA!5e0!3m2!1sbg!2sbg!4v1603103132190!5m2!1sbg!2sbg",
  },
];

export const FooterMenus: FooterMenu[] = [
  {
    title: "Кои сме ние",
    links: [
      { title: "За нас", path: "about-us" },
      { title: "Наши проекти", path: "gallery" },
      { title: "Контакти", path: "contact-us" },
      { title: "Полезна информация", path: "contact-us" },
    ],
  },
  {
    title: "Предлагани услуги",
    links: [
      { title: "Монтаж на климатици", path: "about-us#install" },
      { title: "Профилактика на климатици", path: "about-us#prevention" },
      { title: "Сервиз на климатици", path: "about-us#service" },
      { title: "Безплатен оглед", path: "about-us#consultation" },
    ],
  },
];
